import React, { useEffect, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import Configuration from "../../../configuration";
import Select from "react-select";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { produitAdded, produitGetById, saveImageProduit } from "../../../Redux/produitReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";
import { getActiveLigne } from "../../../Redux/ligneImsReduce";
import Dropzone from "react-dropzone";

function AjouterProduit({ client }) {

  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  var annee = localStorage.getItem("annee");
  var id = 0
  if (isNaN(location.id) === true) document.title = t("Produit.add");
  else {
    id = location.id;
    document.title = t("Produit.update");
  }
  const [file, setFile] = React.useState(null);
  const [fileUrl, setFileUrl] = React.useState(null);
  const [fileNames, setFileNames] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [line, setLine] = React.useState(null);
  const [bu, setBu] = React.useState(null);
  const [bm, setBm] = React.useState(null);
  const [specialite, setSpecialite] = React.useState(null);
  const [promotion, setPromotion] = React.useState(null);
  const [brand, setBrand] = React.useState(null);
  const [buSelect, setBuSelect] = React.useState(null);
  const [bmSelect, setBmSelect] = React.useState(null);
  const [specialiteSelect, setSpecialiteSelect] = React.useState(null);
  const [promotionSelect, setPromotionSelect] = React.useState(null);
  const [brandSelect, setBrandSelect] = React.useState(null);
  const [commentaire, setCommentaire] = React.useState(null);
  const [bi, setBi] = React.useState(0);
  const [lineSelect, setLineSelect] = React.useState(null);
  const [optionLine, setOptionLine] = React.useState(null);
  const [optionBu, setOptionBu] = React.useState(null);
  const [optionBm, setOptionBm] = React.useState(null);
  const [optionPromotion, setOptionPromotion] = React.useState(null);
  const [optionSpecialite, setOptionSepcialite] = React.useState(null);
  const [optionBrand, setOptionBrand] = React.useState(null);
  const [optionStatus, setOptionStatus] = React.useState(null);
  const [imageUpdate, setImageUpdate] = React.useState(0);
  const [produit_ims, setProduit_ims] = React.useState(null);
  const [code_emg, setCode_emg] = React.useState(null);
  const [commerce, setCommerce] = React.useState(1);
  const saveCalled = useRef(false);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }


  const getLine = useCallback(async (s) => {
    var type = await dispatch(getActiveLigne());
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      if (s == e.id) setLineSelect({ value: e.id, label: e.nom })
      arrayOption.push({ value: e.id, label: e.nom });
    });
    setOptionLine(arrayOption);
  }, [dispatch]);




  function uploadImage(event) {
    let ImageFile = event[0];
    setImageUpdate(1)
    if (ImageFile) {
      setFile(ImageFile);
      setFileNames(event[0].name);
      setFileUrl(URL.createObjectURL(event[0]));
    }
  }


  function submitForm(event) {
    if (file != null) {
      const dataArray = new FormData();
      dataArray.append("file", file);
      dataArray.append("name", file.name);
      if (saveCalled.current) return;
      saveCalled.current = true;
      dispatch(saveImageProduit(dataArray))
        .then((val) => {
          var filename = val.payload.filename;
          dispatch(
            produitAdded({
              filename,
              id,
              status,
              commentaire,
              commerce, produit_ims, code_emg, line, bi,bu,bm,promotion
            })
          )
            .then((e) => {
              if (e.payload == true) {
                notify(1, t("add_txt"));
                setTimeout(async () => {
                  navigate.push(client + "/listProduit");
                }, 800);
              } else {
                notify(2, t("problem"));
                saveCalled.current = false;
              }
            })
            .catch((error) => {
              notify(2, t("erreur_add"));
              saveCalled.current = false;
              console.error("Error updating produit:", error);
            });
        })
        .catch((error) => {
          notify(2, t("erreur_add"));
          saveCalled.current = false;
          console.error("Error updating produit:", error);
        });
    } else {

      dispatch(
        produitAdded({
          fileNames,
          id,
          status,
          commentaire,
          commerce, produit_ims, code_emg, line, bi,bu,bm,promotion
        })
      )
        .then((e) => {
          if (e.payload == true) {
            notify(1, t("add_txt"));
            setTimeout(async () => {
              navigate.push(client + "/listProduit");
            }, 800);
          } else {
            notify(2, t("problem"));
            saveCalled.current = false;
          }
        })
        .catch((error) => {
          notify(2, t("erreur_add"));
          saveCalled.current = false;
          console.error("Error updating produit:", error);
        });

    }


  }


  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    async function getProduit() {
      if (isNaN(location.id) === false) {
        var produit = await dispatch(produitGetById(location.id));
        var entities = produit.payload;

        if (entities === false) {
          navigate.push(client + '/listProduit');
        }
        else {
          getLine(entities.id_line);
          setCommentaire(entities.commentaire)
          setStatus(entities.id_status)
          setFileNames(entities.image);
          setFileUrl(entities.image);
          setCommerce(entities.commerce);
          setProduit_ims(entities.produit_ims);
          setCode_emg(entities.Code_emg);
          setBi(entities.bi);
        }
      } else {
        getLine()
      }
    }
    getProduit();
  }, [location.id, dispatch, navigate]);

  function listeProduit() {
    navigate.push(client + '/listProduit');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeProduit}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('Produit.add')
                        : t('Produit.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="12">
                        <Dropzone onDrop={uploadImage}>
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps({
                                className: "dropzone",
                              })}
                            >
                              <input {...getInputProps()} />
                              <p>
                                {fileUrl !== null ? (
                                  <div>
                                    <img
                                      src={id == 0 ? fileUrl : imageUpdate == 0 ? Configuration.BACK_BASEURL + "produit/" + fileUrl : fileUrl}
                                      className="img-file"
                                      alt=""
                                    ></img>

                                  </div>) :
                                  <div><i className="fas fa-file-alt fileUpload"></i><br></br>Il y a aucune image selectionner</div>}
                              </p>
                              <p>Choisissez une image</p>
                            </div>
                          )}
                        </Dropzone>
                      </Col>

                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>Désignation ims </label>
                          <Form.Control
                            defaultValue={produit_ims}
                            placeholder="Désignation ims"
                            name="Email"
                            type="text"
                            onChange={(value) => {
                              setProduit_ims(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pl-1" md="6">
                        <Form.Group id="roleClass">
                          <label>Line </label>
                          <Select
                            placeholder={"line"}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={lineSelect}
                            onChange={(value) => {
                              setLineSelect(value);
                              setLine(value.value);
                            }}
                            options={optionLine}
                          />
                        </Form.Group>
                      </Col>

                      <Col className="pl-1" md="6">
                        <br></br>

                        <Form.Group className="pull-left">
                          <Form.Check className="pull-right">
                            <Form.Check.Label>
                              <Form.Check.Input
                                type="checkbox"
                                checked={bi == 1 ? true : false}
                                onClick={(value) => {
                                  if (value.target.checked) {
                                    setBi(1);
                                  } else {
                                    setBi(0);
                                  }
                                }}
                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                              <label>Visualiser BI</label>
                            </Form.Check.Label>
                          </Form.Check>
                        </Form.Group>
                      </Col>
                      {/* <Col md="6">
                        <Form.Group>
                          <Form.Check>
                            <Form.Check.Label>
                              <Form.Check.Input
                                type="checkbox"
                                checked={commerce == 1 ? true : false}
                                onChange={(v) => {
                                  if (v.target.checked) {
                                    setCommerce(1);
                                  }
                                  else setCommerce(0)
                                }}
                              ></Form.Check.Input>
                              <span className="form-check-sign"></span>
                              <label>{t('commercialise')}</label>
                            </Form.Check.Label>
                          </Form.Check>
                        </Form.Group>
                      </Col> */}
                    </Row>
        
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container >
    </>
  );
}

export default AjouterProduit;
